import React from 'react'
import { connect } from 'react-redux'
import { getZoom, getZoomableInstance } from '@/store/getters'
import { setZoom } from '@/store/actions'

import styles from './styles.scss'

/** Components */
import IconComponent from '@/components/commons/IconComponent'

const ZoomControl = (props) => {

  const { actualZoom, zoomInstance, setZoom } = props
  const centerX = window.innerWidth / 2
  const centerY = window.innerHeight / 2
  const FACTOR = 0.1

  const handleZoomOut = (e) => {
    e.preventDefault()

    let { scale } = actualZoom
    if (scale <= 0.1) return;

    scale = +(scale - FACTOR).toFixed(2)
    zoomInstance.zoomAbs(centerX, 0, scale)
    setZoom(zoomInstance.getTransform())
  }

  const handleZoomIn = e => {
    e.preventDefault()

    let { scale } = actualZoom
    scale = +(scale + FACTOR).toFixed(2)
    zoomInstance.zoomAbs(centerX, 0, scale)
    setZoom(zoomInstance.getTransform())
  }

  const clearZoom = () => {
    zoomInstance.zoomAbs(centerX, centerY, 1)
    setZoom(zoomInstance.getTransform())
  }

  return props.zoomInstance &&
    <div className={styles['zoom-control']}>
      <button onClick={handleZoomIn} className='ba-btn ba-btn-normal ba-sm ba-rounded'>
        <IconComponent icon='zoom-plus' />
      </button>
      <span className='ba-montserrat-400 ba-color-blue1' onClick={clearZoom}>
        {Math.round(actualZoom.scale * 100)}%
      </span>
      <button onClick={handleZoomOut} className='ba-btn ba-btn-normal ba-sm ba-rounded'>
        <IconComponent icon='zoom-minus' />
      </button>
      {/* <hr className={styles['hr']} />
      <button class='ba-btn ba-btn-normal ba-sm ba-rounded'>
        <builderall-icon code='94e2'></builderall-icon>
      </button> */}
    </div>
}

const mapStateToProps = state => {
  const actualZoom = getZoom(state)
  const zoomInstance = getZoomableInstance(state)
  return {
    actualZoom,
    zoomInstance
  }
}
export default connect(
  mapStateToProps,
  { setZoom }
)(ZoomControl)



// WEBPACK FOOTER //
// ./src/pages/Editor/components/ZoomControl/index.js